import { render } from "../templates/benefitCard.html?vue&type=template&id=063a4790"
import script from "./benefitCard.vue?vue&type=script&lang=js"
export * from "./benefitCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__